import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { VipBadge } from "@/components/VipBadge";

export function VipCard({ vip }) {
  if (!vip || !vip.tiers?.length) return null;
  const total = vip.total_deposited || 0;
  const pct = vip.next_min ? Math.min(100, (total / vip.next_min) * 100) : 100;
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} data-testid="vip-card"
      className="rounded-2xl pz-glass p-5 mb-4 border border-pazer-red/30">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2">
          <Crown className="h-5 w-5 text-pazer-red" />
          <h3 className="font-display font-bold">VIP Club</h3>
        </div>
        {vip.tier ? <VipBadge tier={vip.tier} size="lg" testid="vip-card-tier" />
          : <span className="text-xs text-white/50" data-testid="vip-card-tier">Not VIP yet</span>}
      </div>
      {vip.tier && (
        <p className="text-sm text-white/80 mb-3" data-testid="vip-card-perk">
          You get <span className="text-pazer-red font-bold">+{vip.bonus_percent}% bonus</span> on every deposit.
        </p>
      )}
      <div className="h-2 rounded-full bg-white/10 overflow-hidden">
        <motion.div initial={{ width: 0 }} animate={{ width: `${pct}%` }} transition={{ duration: 0.8 }} className="h-full bg-pazer-red rounded-full" />
      </div>
      <div className="flex justify-between text-xs text-white/50 mt-2" data-testid="vip-card-progress">
        <span>Deposited ₹{total.toLocaleString()}</span>
        {vip.next_tier ? <span>₹{(vip.next_min - total).toLocaleString()} more to {vip.next_tier}</span> : <span>Top tier reached</span>}
      </div>
      <div className="grid grid-cols-3 gap-2 mt-4">
        {vip.tiers.map((t) => (
          <div key={t.name} className={`rounded-xl p-2.5 text-center border ${vip.tier === t.name ? "border-pazer-red bg-pazer-red/10" : "border-white/10 bg-white/5"}`}>
            <VipBadge tier={t.name} testid={`vip-tier-${t.name.toLowerCase()}`} />
            <div className="text-[11px] text-white/60 mt-1">₹{t.min_deposit.toLocaleString()}+</div>
            <div className="text-xs font-bold text-pazer-red">+{t.bonus_percent}%</div>
          </div>
        ))}
      </div>
      {vip.next_tier && (
        <Link to="/wallet" data-testid="vip-card-deposit" className="mt-4 block text-center py-2.5 rounded-full bg-pazer-red hover:bg-pazer-redhover font-bold text-sm transition-colors">
          Deposit to reach {vip.next_tier}
        </Link>
      )}
    </motion.div>
  );
}
